import { DecorativePlacement } from "./DecorativePlacement";
import {
  REGISTER_SUCCESS_DECORATIONS,
  REGISTER_SUCCESS_FIGMA_FRAME_MIN_HEIGHT,
  REGISTER_SUCCESS_FIGMA_FRAME_WIDTH,
} from "./register-success-decorations.constants";

export function RegisterSuccessDecorations() {
  return (
    <div
      aria-hidden="true"
      data-testid="register-success-decorations"
      className="pointer-events-none absolute inset-0 hidden overflow-hidden lg:block"
    >
      <div
        data-testid="register-success-decorations-frame"
        className="relative mx-auto h-full w-full"
        style={{
          maxWidth: REGISTER_SUCCESS_FIGMA_FRAME_WIDTH,
          minHeight: REGISTER_SUCCESS_FIGMA_FRAME_MIN_HEIGHT,
        }}
      >
        {REGISTER_SUCCESS_DECORATIONS.map(({ id, Icon, placement, iconProps }) => (
          <DecorativePlacement key={id} id={id} style={placement}>
            <Icon className="h-full w-full" {...iconProps} />
          </DecorativePlacement>
        ))}
      </div>
    </div>
  );
}
